import React, { Component, Fragment } from 'react'
import { connect } from 'react-redux'
import numeral from 'numeral'

import {
    formatcoin, getDivisa
} from '../../utils/helpers'


import AttachedInvoicesBox from '../Shared/AttachedInvoicesBox'
import BoxSection from '../Layout/BoxSection'
import { RowControlFacturacion } from './RowControlFacturacion';

class Facturas extends Component {

    calcularTotales = (doc, origen) => {
        let total = 0
        if (doc.get('estado') == 0) {
            return total;
        }
        if (doc.get('documentos')) {
            doc.get('documentos').map(d => total += this.calcularTotales(d, doc))
        }
        if (doc.get('tipo') == 6) {
            const totalSevicios = origen.get('detalles').reduce((a, b) => {
                if (!b.get('adicion_id')) a += (b.get('valor') * b.get('cantidad'))
                return a
            }, 0)
            //total -= Math.round((totalSevicios * (origen.get('anticipo'))) / 100)
            total -= (totalSevicios * (origen.get('anticipo'))) / 100
        } else {
            total += doc.get('detalles').reduce((a1, b1) => { a1 += b1.get('valor_con_iva') * b1.get('cantidad'); return a1 }, 0)
        }
        return total;
    }


    calcularTotalesSinAnticipo = (doc) => {
        let total = 0
        if (doc.get('estado') == 0) {
            return total;
        }
        if (doc.get('documentos')) {
            doc.get('documentos').map(d => total += this.calcularTotalesSinAnticipo(d))
        }
        total += doc.get('detalles').reduce((a1, b1) => { a1 += b1.get('valor_con_iva') * b1.get('cantidad'); return a1 }, 0)
        return total;
    }


    obtenerDetalles = (documento) => {

        const totales = {
            sin_iva: 0,
            con_iva: 0,
            sin_iva_sin_adiciones: 0,
            con_iva_sin_adiciones: 0
        }        

        documento.get('detalles').forEach(a => {

            totales.sin_iva += a.get('valor') * a.get('cantidad')
            totales.con_iva += a.get('valor_con_iva') * a.get('cantidad')

            if (a.get('adicion_id') === null) {
                totales.sin_iva_sin_adiciones += a.get('valor') * a.get('cantidad')
                totales.con_iva_sin_adiciones += a.get('valor_con_iva') * a.get('cantidad')
            }

        })

        return totales
    }



    obtenerTotalAnticipo = (documento) => {

        const totales = {
            valor_total_anticipos: 0,
            anticipo_legalizado: 0,
            pendiente_legalizar: 0
        }  
        
        const documentos = []

        documentos.push(documento)

        documento.get('documentos').filter(d => d.get('tipo') == 4).map(x => {
            documentos.push(x)
        }) 

        const valor_total_anticipos = documentos.reduce(function(acc1, current1) {
            const anticipo = current1.get('anticipo')
            const total_detalles = current1.get('detalles').reduce(function(acc2, current2) {
                if (current2.get('adicion_id') === null) {
                    acc2 += current2.get('valor') * current2.get('cantidad')
                }
                return  acc2
            }, 0)
            acc1 += (anticipo / 100) * total_detalles
            return acc1
        }, 0)

        totales.valor_total_anticipos = valor_total_anticipos

        const anticipo_legalizado = documentos.reduce(function(acc1, current1) {
            return acc1  += current1.get('anticipo_legalizado') || 0
        }, 0)

        totales.anticipo_legalizado = anticipo_legalizado

        totales.pendiente_legalizar = valor_total_anticipos - totales.anticipo_legalizado

        return totales

    }


    obtenerTotalFacturacion = (documento) => {

        const totales = {
            sin_iva: 0,
            con_iva: 0
        }

        const documentos = []

        documentos.push(documento)

        documento.get('documentos').filter(d => d.get('tipo') == 4).map(x => {
            documentos.push(x)
        }) 


        const sin_iva = documentos.reduce(function(acc1, current1) {
            acc1 += current1.get('detalles').reduce(function(acc2, current2) {     
                 return  acc2 += current2.get('valor') * current2.get('cantidad')   
            }, 0)
            return acc1
        }, 0)

        const con_iva = documentos.reduce(function(acc1, current1) {
            acc1 += current1.get('detalles').reduce(function(acc2, current2) {     
                 return  acc2 += current2.get('valor_con_iva') * current2.get('cantidad')   
            }, 0)
            return acc1
        }, 0)

        totales.sin_iva = sin_iva

        totales.con_iva = con_iva

        return totales

    }



	render() {

        const { documento, enums, divisas } = this.props
        if (!documento) return null

        const moneda = documento.getIn(['cotizacion', 'moneda']);
        const divisa = getDivisa(divisas, moneda)

        const cencos = {}
        const totales = this.obtenerDetalles(documento) 

        const totalAnticipo = this.obtenerTotalAnticipo(documento)    
        
        const totalFacturacion =  this.obtenerTotalFacturacion(documento)

        const por_recibir = documento.get('entregas').filter(e => e.get('recibido') == false).count() > 0;

        documento.get('todos_detalles').forEach((a, b) => {
            a.get('cencos').forEach((c, d) => {
                if (!cencos[c.get('codigo')]) cencos[c.get('codigo')] = {
                    codigo: null,
                    descripcion: null,
                    total: 0
                }
                cencos[c.get('codigo')].codigo = c.get('codigo')
                cencos[c.get('codigo')].descripcion = c.get('descripcion')
                cencos[c.get('codigo')].total += (Number(c.get('porcentaje')) / 100) * (a.get('valor_con_iva') * a.get('cantidad'))
            })
        })

        totales.facturado = documento.get('facturas').reduce((acc, current) => acc+current.get('valor_con_iva'), 0)


        let saldo = Math.round(this.calcularTotalesSinAnticipo(documento), 2) - Math.round(totales.facturado, 2) 

        const saldoTotal = this.calcularTotalesSinAnticipo(documento) - totales.facturado
        

		return (
            <div>
                <div className="row">
                    <div className="col-md-8">
                        <BoxSection title="Control de facturación">
                            <div style={{ height: '120px', overflowX: 'hidden' }}>
                                <table className="table table-condensed table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th rowSpan={2}>Documento</th>
                                            <th colSpan={2} style={{ textAlign: 'center' }}>Valor</th>
                                            <th colSpan={2} style={{ textAlign: 'center' }}>Anticipo</th>
                                            <th rowSpan={2}>Saldo Documento</th>
                                            <th rowSpan={2}>Anticipo por Legalizar</th>
                                        </tr>
                                        <tr>
                                            <th>Antes de IVA</th>
                                            <th>Total</th>
                                            <th>%</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>
                                    <tbody>

                                        <tr>
                                            <td>{ enums.documentos.tipos[documento.get('tipo')].PREFIJO + documento.get('consecutivo') }</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((totales.sin_iva),divisa.simbolo) }</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((totales.con_iva),divisa.simbolo) }</td>
                                            <td style={{ textAlign: 'right' }}>0%</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin(0, divisa.simbolo ) }</td>
                                            <td style={{ textAlign: 'right' }} rowSpan={documento.get('documentos').count() * 2 } >{ formatcoin(saldo, divisa.simbolo) }</td>
                                            <td style={{ textAlign: 'right' }} rowSpan={documento.get('documentos').count() * 2 } >{ formatcoin(totalAnticipo.pendiente_legalizar, divisa.simbolo) }</td>
                                        </tr>

                                        {
                                            documento.get('documentos').map((d, i) =>
                                                d.get('estado') > 0 ?
                                                <RowControlFacturacion origen={documento} documento={d} enums={enums} totalDetalles={this.obtenerDetalles} divisa={divisa} key={`tr12[${i}]`} />
                                                : null
                                            )
                                        }

                                    </tbody>
                                </table>

                            </div>
                        </BoxSection>
                    </div>
                    <div className="col-md-4">
                        <BoxSection title="Distribución del gasto">
                            <div style={{ height: '120px', overflowX: 'hidden' }}>
                                <table className="table table-condensed table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th colSpan="2" style={{ textAlign: 'center' }}>Centro de costo</th>
                                            {/* <th rowSpan="2">%</th> */}
                                            <th rowSpan="2">Valor</th>
                                        </tr>
                                        <tr>
                                            <th>Código</th>
                                            <th>Descripción</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {
                                            Object.keys(cencos).map(x => {
                                                return (
                                                    <tr key={ `tr10[${x}]` }>
                                                        <td>{ cencos[x].codigo }</td>
                                                        <td>{ cencos[x].descripcion }</td>
                                                        {/* <td style={{ textAlign: 'right' }}>{ numeral(cencos[x].total / totales.con_iva).format('0.0%') }</td> */}
                                                        <td style={{ textAlign: 'right' }}>{ formatcoin((cencos[x].total), divisa.simbolo) }</td>
                                                    </tr>
                                                )
                                            })
                                        }
                                        <tr>
                                            <td colSpan={2} style={{ textAlign: 'right' , fontWeight: 'bold'}}>Total</td>
                                            <td style={{ textAlign: 'right' }}>{ formatcoin((totalFacturacion.con_iva), divisa.simbolo) }</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </BoxSection>
                    </div>
                </div>

                <div className="separator" />

                {por_recibir && (
                <Fragment>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="alert alert-warning" style={{fontWeight: 'bold', border: '1px solid #8a6d3b'}}>
                                Para cargar facturas adicionales, el usuario debe recibir y calificar la entrega parcial.
                            </div>
                        </div>
                    </div>
                    <div className="separator" />
                </Fragment>
                )}

                <div className="row">
                    <div className="col-md-12">
                        <AttachedInvoicesBox saldo={saldoTotal} por_recibir={por_recibir} divisa={divisa} />
                    </div>
                </div>
            </div>
		)
	}
}

function mapStateToProps(state, ownProps) {
    return {
        documento: state.documentos.getIn(['modalSummary', 'data']),
        enums: state.common.get('enums').toJS(),
        divisas: state.common.getIn(['parametros', 'DIVISAS']) 
    }
}

function mapDispatchToProps(dispatch) {
    return {
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Facturas)


// WEBPACK FOOTER //
// ./src/components/Documentos/Facturas.jsx